var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navigator" }, [
    _c("a", { on: { click: _vm.previous } }, [
      _c(
        "svg",
        {
          staticClass: "bi bi-arrow-left-short",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            viewBox: "0 0 16 16",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              d: "M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z",
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("a", { on: { click: _vm.next } }, [
      _c(
        "svg",
        {
          staticClass: "bi bi-arrow-right-short",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            viewBox: "0 0 16 16",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              d: "M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z",
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.page,
            expression: "page",
          },
        ],
        staticClass: "form-control",
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          },
        },
      },
      _vm._l(_vm.questions, function (question) {
        return _c(
          "option",
          { key: question.index, domProps: { value: question.index } },
          [_vm._v("\n      " + _vm._s(question.index) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-outline-success revision-btn me-2",
        attrs: { type: "button" },
        on: { click: _vm.changeMode },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.isRevisionMode ? "編集をキャンセル" : "ヒストリー編集") +
            "\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }